module.exports = __webpack_public_path__ + "static/media/browse-electric-vehicles.06720783.svg";